// Single source of truth for API paths used by the portal frontend.

export const ENDPOINTS = {
  auth: {
    register: '/api/auth/register',
    login: '/api/auth/login',
    logout: '/api/auth/logout',
    refresh: '/api/auth/refresh',
    me: '/api/auth/me',
    impersonate: '/api/auth/impersonate',
    token: '/api/auth/token',
    setPassword: '/api/auth/set-password',
    forgot: '/api/auth/forgot',
    changePassword: '/api/auth/change-password',
  },
  admin: {
    users: '/api/admin/users',
    usersByStatus: (status) => `/api/admin/users?status=${encodeURIComponent(status)}`,
    clients: (q) => `/api/admin/users?role=client${q ? `&q=${encodeURIComponent(q)}` : ''}`,
    pricing: '/api/admin/pricing',
    settings: '/api/admin/settings',
    entitlements: '/api/admin/entitlements',
    leads: '/api/admin/leads',
    orders: '/api/admin/orders',
  },
  pricing: '/api/pricing',
  leads: '/api/leads',
  siteCheck: {
    base: '/api/site-check',
    one: (token) => `/api/site-check/${encodeURIComponent(token)}`,
    unlock: (token) => `/api/site-check/${encodeURIComponent(token)}/unlock`,
  },
  checkout: '/api/create-checkout-session',
  engine: {
    prospects: '/api/engine/prospects',
    capabilities: '/api/engine/capabilities',
    outreach: '/api/engine/outreach',
    command: '/api/engine/command',
    plans: '/api/engine/plans',
    campaigns: '/api/engine/campaigns',
    tasks: '/api/engine/tasks',
    analytics: '/api/engine/analytics',
    integrations: '/api/engine/integrations',
    settings: '/api/engine/settings',
    jobs: '/api/engine/jobs',
    programs: '/api/engine/programs',
    salesDesk: '/api/engine/sales-desk',
    studio: '/api/engine/studio',
    mailbox: '/api/engine/mailbox',
    crm: '/api/engine/crm',
    control: '/api/engine/control',
    voice: '/api/engine/voice',
  },
};

// Stable cache keys: params are sorted and empty values dropped.
export function engineUrl(path, params = {}) {
  const query = Object.keys(params)
    .filter((k) => params[k] !== undefined && params[k] !== null && params[k] !== '')
    .sort()
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
  return query ? `${path}?${query}` : path;
}

export default ENDPOINTS;
